(() => {
  const SENTINEL_ID = 'infinite-scroll-sentinel';
  const SPINNER_ID  = 'infinite-scroll-spinner';
  const NEXT_SELECTOR = '.pagination__item--prev.pagination__item-arrow';

  function getNextHref() {
    const el = document.querySelector(NEXT_SELECTOR);
    if (!el) return null;
    const raw = el.getAttribute('href');
    if (!raw) return null;
    try { return new URL(raw, window.location.origin).href; } catch { return null; }
  }

  function hidePagination() {
    document.querySelectorAll('.pagination-wrapper').forEach(el => el.style.display = 'none');
  }

  let facetObserver = null;
  let scrollObserver = null;

  function init() {
    // Clean up previous scroll observer
    scrollObserver?.disconnect();
    scrollObserver = null;

    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const nextHref = getNextHref();
    if (!nextHref) return;

    hidePagination();

    // Place sentinel at the bottom of the page using a fixed bottom anchor
    let sentinel = document.getElementById(SENTINEL_ID);
    if (!sentinel) {
      sentinel = document.createElement('div');
      sentinel.id = SENTINEL_ID;
      // Position it in the normal flow right after the grid's parent .collection div
      const collectionDiv = grid.closest('.collection') || grid.parentElement;
      collectionDiv.appendChild(sentinel);
    }
    // Give it explicit dimensions so IntersectionObserver can detect it
    sentinel.style.cssText = 'display:block;height:10px;width:100%;clear:both;';

    let spinner = document.getElementById(SPINNER_ID);
    if (!spinner) {
      spinner = document.createElement('div');
      spinner.id = SPINNER_ID;
      spinner.style.cssText = 'text-align:center;padding:2rem;display:none;';
      spinner.innerHTML = `
        <style>@keyframes __is-spin{to{transform:rotate(360deg)}}</style>
        <div style="width:3rem;height:3rem;border:3px solid rgba(0,0,0,.12);border-top-color:rgb(var(--color-foreground,0,0,0));border-radius:50%;animation:__is-spin .8s linear infinite;margin:0 auto;"></div>
      `;
      sentinel.after(spinner);
    }

    let currentNext = nextHref;
    let loading = false;

    scrollObserver = new IntersectionObserver(async (entries) => {
      if (!entries[0].isIntersecting || loading || !currentNext) return;
      loading = true;
      spinner.style.display = 'block';

      facetObserver?.disconnect();

      try {
        const url = new URL(currentNext);
        url.searchParams.set('section_id', grid.dataset.id);

        const res = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = doc.getElementById('product-grid');
        if (newGrid) {
          // Append into the <ul> if present (search page), otherwise directly into the grid element (collection page)
          const targetList = grid.querySelector('ul.product-grid') || grid;
          newGrid.querySelectorAll('.grid__item').forEach(item => targetList.appendChild(item));
        }

        const newNextEl = doc.querySelector(NEXT_SELECTOR);
        if (newNextEl) {
          const raw = newNextEl.getAttribute('href');
          const base = new URL(currentNext);
          base.searchParams.delete('section_id');
          currentNext = raw ? new URL(raw, base.origin + base.pathname).href : null;
        } else {
          currentNext = null;
        }

        if (!currentNext) scrollObserver.disconnect();
      } catch (e) {
        console.error('[IS] fetch failed:', e);
        scrollObserver.disconnect();
      } finally {
        loading = false;
        spinner.style.display = 'none';
        reattachFacetObserver();
      }
    }, { rootMargin: '200px', threshold: 0 });

    scrollObserver.observe(sentinel);
  }

  function reattachFacetObserver() {
    facetObserver?.disconnect();
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;

    let prevGrid = document.getElementById('product-grid');

    facetObserver = new MutationObserver(() => {
      const currentGrid = document.getElementById('product-grid');
      if (currentGrid && currentGrid !== prevGrid) {
        prevGrid = currentGrid;
        document.getElementById(SENTINEL_ID)?.remove();
        document.getElementById(SPINNER_ID)?.remove();
        // Wait for facet AJAX to finish painting before re-init
        setTimeout(init, 300);
      }
    });

    facetObserver.observe(container, { childList: true, subtree: true });
  }

  // Use window load to guarantee full layout before placing sentinel
  window.addEventListener('load', () => {
    init();
    reattachFacetObserver();
  });
})();
